import PropTypes from 'prop-types';
import React from 'react';

const ArticleStatusText = ({ entity }) => {
    if (entity.is_draft) {
        const publishingDate = entity.published_at
            ? new Date(entity.published_at).toLocaleString()
            : '-';

        return (
            <div>
                <p className="text-red text-3xl font-bold text-center">
                    Unreleased Draft
                </p>
                <p className="text-red text-3xl font-bold">
                    Publishing date: {publishingDate}
                </p>
            </div>
        );
    }
    return null;
};

export default ArticleStatusText;

ArticleStatusText.propTypes = {
    entity: PropTypes.object.isRequired,
};
